import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { AcpService } from '@services/common/acp.service';
import { ComActionService } from '@services/common/com-action.service';
import { FactoryService } from '@services/common/factory.service';
import { ErrInfo, ErrInfo_EN, ErrInfo_ZH } from '@models/com-err-model';
import { PlatformDetect } from '@core/libs/platform/platform-detect';
@Component({
  standalone: false,
  selector: 'com-error',
  templateUrl: './com-error.component.html',
  styleUrls: ['./com-error.component.scss']
})
export class ComErrorComponent implements OnInit, OnDestroy {
  @Input() mobileStye: boolean = false;
  @Input() errList: ErrInfo[];
  
  public btnTxt: string;
  public returnFlag: boolean = false; //user for show return btn, and to do return logic when click return btn
  public timeout = 0;
  public timmer;
  public defaultImg: string; 
  public errImg: string;
  public errMsg: string = 'Profile.Common.Refresh.Desc';
  public errInfo: ErrInfo;

  constructor(
    private acpSer: AcpService,
    public factorySer: FactoryService,
    private comActSer: ComActionService,
    private platform: PlatformDetect
  ) {
    this.initData();
  }

  ngOnInit() {
    this.defaultImg = this.acpSer.getAcpMedia('Profile.Common.Error.Img');
  }

  private initData() { 
    this.btnTxt = this.acpSer.getAcpText('Profile.Common.Txt.Refresh');
    const errCode = this.factorySer.errCode;
    const errList: ErrInfo[] = this.errList || this.factorySer.errList || this.factorySer.getSessionInfo(`errList.${this.factorySer.language}`, true);
    if(errCode && errList && errCode!=='others' && errCode!=='429') {
      this.errInfo = errList.find(item => item.errorCode === errCode);
      this.btnTxt = this.errInfo?.ctaName;
      this.returnFlag = /(404)/.test(this.errInfo?.errorCode);
      this.errImg = this.errInfo?.images[0]?.BinaryContent?.url;
    }
    // errCode=429以及errCode在trddion没有对应配置的场景，都展示默认错误信息
    if(!errCode || errCode === '429' || !this.errInfo) {
      this.errInfo = this.factorySer.language === 'zh-cn' ? ErrInfo_ZH : ErrInfo_EN;
      this.btnTxt = this.errInfo?.ctaName;
      this.errInfo.title = '';
      this.returnFlag = false;
    }
    if(!this.returnFlag) {
      this.timeout = 5
      this.timmer = setInterval(() => {
        if (this.timeout > 0) {
          this.timeout--;
        } else {
          clearInterval(this.timmer)
        }
      }, 1000)
    }
  }

  public btnAction(): void { 
    if (this.returnFlag) {
      this.factorySer.errCode = null;
      if (this.platform.isWeb()) {
        location.replace(this.errInfo?.ctaLink[0]?.webExternalLink);
      } else { 
        this.comActSer.routingCheck();
      }
    } else { 
      if(this.timeout === 0) {
        location.reload();
      }
    }
  }

  ngOnDestroy(): void {
    if(this.timmer) {
      clearInterval(this.timmer);
    }
  }

}
